import { gql } from '@apollo/client';

export const UPDATE_BAKER_USER_MUTATION = gql`
  mutation UpdateBakerUser($bakerUserUpdateDto: BakerUserUpdateDto!) {
    updateBakerUser(userUpdateDto: $bakerUserUpdateDto) {
      email
      profile
      inventory
      loans
      lseg
      dailyPricing
      reports
      portfolios
      cashFlows
      swapIQ
      houstonTrust
      empyreanImport
      yieldBookMonitor
    }
  }
`;
